module.exports = __webpack_public_path__ + "static/media/IMG_20180806_192146.8314defb.jpg";